/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_DisclaimerInputs */

const en_control_disclaimer = /** @type {(inputs: Control_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Independent fan-made resource. Not affiliated with Remedy Entertainment or the CONTROL rights holders. All trademarks belong to their respective owners.`)
};

const zh_control_disclaimer = /** @type {(inputs: Control_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立粉丝制作的资源，与 Remedy Entertainment 及 CONTROL 权利人无关联。商标归各自所有者所有。`)
};

/**
* | output |
* | --- |
* | "Independent fan-made resource. Not affiliated with Remedy Entertainment or the CONTROL rights holders. All trademarks belong to their respective owners." |
*
* @param {Control_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_disclaimer = /** @type {((inputs?: Control_DisclaimerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_DisclaimerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_disclaimer(inputs)
	return zh_control_disclaimer(inputs)
});
export { control_disclaimer as "control.disclaimer" }